/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiDynamicExportParameters, ApiDynamicExportRun } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of DynamicExportRunController.
 */
export class DynamicExportRunRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /export_runs:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiDynamicExportRun>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiDynamicExportRun>>>('/export_runs:query', query);
    }

    /**
     * Calls POST /export_runs:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiDynamicExportRun>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiDynamicExportRun>>, ListRequest>('/export_runs:query', listRequest, query);
    }

    /**
     * Calls POST /export_runs:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiDynamicExportRun>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiDynamicExportRun>>, ListRequestWithIds>('/export_runs:batch', listRequest, query);
    }

    /**
     * Calls POST /export_runs
     */
    public scheduleDynamicExportRun(definition: string, request: ApiDynamicExportParameters): Promise<Result<string>> {
        const query = new URLSearchParams();
        query.set('definition', `${definition}`);

        return this.http.post<Result<string>, ApiDynamicExportParameters>('/export_runs', request, query);
    }

    /**
     * Calls GET /export_runs/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiDynamicExportRun>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiDynamicExportRun>>(`/export_runs/${primaryId}`, query);
    }
}
